import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { I18nextProvider } from 'react-i18next';
import './styles/globals.css';
import HomePage from './components/home';
import CompanyInfoPage from './components/company';
import CareersPage from './components/careers';
import NewsPage from './components/news';
import ContactPage from './components/contact';
import PolicyPage from './components/policy';
import OrderMatePage from './components/order-mate';
import ReparuPage from './components/reparu';
import MessagePage from './components/message';
import { store, persistor } from './store';
import i18n from './i18n';
import theme from './thema';


function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <I18nextProvider i18n={i18n}>
          <ThemeProvider theme={theme}>
            <Router>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/company" element={<CompanyInfoPage />} />
                <Route path="/message" element={<MessagePage />} />
                {/* 旧サービスページはトップページの該当セクションへ統合 */}
                <Route path="/service" element={<Navigate to="/#services" replace />} />
                <Route path="/careers" element={<CareersPage />} />
                <Route path="/news" element={<NewsPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/policy" element={<PolicyPage />} />
                <Route path="/system-development" element={<Navigate to="/#services" replace />} />
                <Route path="/app-development" element={<Navigate to="/#services" replace />} />
                <Route path="/maintenance" element={<Navigate to="/#maintenance" replace />} />
                <Route path="/order-mate" element={<OrderMatePage />} />
                <Route path="/reparu" element={<ReparuPage/>}/>
              </Routes>
            </Router>
          </ThemeProvider>
        </I18nextProvider>
      </PersistGate>
    </Provider>
  );
}

export default App;
